<template>
  <div class="p-0">
    <!-- Yeni yatay düzen layoutu -->
    <div class="md:flex md:p-4 md:gap-6">
      <!-- Sol Sütun - Görsel -->
      <div v-if="isImageLink || (linkPreview && linkPreview.image)" class="md:w-2/5 flex-shrink-0 md:p-0 p-4 flex justify-center">
        <div class="relative overflow-hidden rounded-lg border border-gray-100 shadow-sm" style="max-height: 350px; width: 100%;">
          <img :src="isImageLink ? link : linkPreview.image" alt="Content Preview" class="object-contain max-h-[350px] w-full"/>

          <!-- Görsel için öneri butonu -->
          <div v-if="contentId" class="absolute bottom-3 right-3">
            <suggestion-button :content-id="contentId" content-model="Image" content-type="IMAGE" content-category="SOCIAL_MEDIA" :current-image-url="isImageLink ? link : linkPreview.image" button-text="Görsel Önerisi" icon="auto_fix_high" color="header" size="sm" variation="outline" @suggestion-created="handleSuggestionCreated"/>
          </div>
        </div>
      </div>

      <!-- Sağ Sütun - İçerik metni -->
      <div class="md:flex-1 px-5 py-4 md:p-0 bg-white md:bg-transparent">
        <div class="md:bg-white md:p-4 md:rounded-lg md:border md:border-gray-100 md:shadow-sm">
          <p class="text-gray-800 text-sm whitespace-pre-line leading-relaxed mb-4">{{ message }}</p>

          <!-- Metin için öneri butonu -->
          <div v-if="contentId && message" class="mb-3">
            <suggestion-button :content-id="contentId" content-model="TextContent" content-type="TEXT" content-category="SOCIAL_MEDIA" :current-text="message" button-text="Metin Önerisi" icon="auto_fix_high" color="secondary" size="sm" variation="outline" @suggestion-created="handleSuggestionCreated"/>
          </div>

          <div v-if="hashtags && hashtags.length" class="flex flex-wrap gap-1.5 mb-3">
            <span v-for="(tag, index) in hashtags" :key="index" class="text-primary text-xs font-medium bg-primary/10 px-2 py-0.5 rounded-full">
              {{ tag }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Görsel olmayan içerikler için mobil görünüm -->
    <div v-if="!(isImageLink || (linkPreview && linkPreview.image))" class="p-4">
      <div class="bg-white p-4 rounded-lg border border-gray-100 shadow-sm">
        <p class="text-gray-800 text-sm whitespace-pre-line leading-relaxed mb-4">{{ message }}</p>

        <!-- Metin için öneri butonu -->
        <div v-if="contentId && message" class="mb-3">
          <suggestion-button :content-id="contentId" content-model="TextContent" content-type="TEXT" content-category="SOCIAL_MEDIA" :current-text="message" button-text="Metin Önerisi" icon="auto_fix_high" color="secondary" size="sm" variation="outline" @suggestion-created="handleSuggestionCreated"/>
        </div>

        <div v-if="hashtags && hashtags.length" class="flex flex-wrap gap-1.5 mb-3">
          <span v-for="(tag, index) in hashtags" :key="index" class="text-primary text-xs font-medium bg-primary/10 px-2 py-0.5 rounded-full">
            {{ tag }}
          </span>
        </div>
      </div>
    </div>

    <!-- Link Preview (Resim olmayan linkler için) -->
    <div v-if="link && !isImageLink && (!linkPreview || !linkPreview.image)" class="p-4">
      <div class="bg-white p-3 rounded-lg border border-gray-100 shadow-sm">
        <div>
          <a :href="link" target="_blank" class="text-primary hover:underline font-medium text-sm flex items-center gap-1.5" @click.prevent="$emit('visit-link', link)">
            <span class="material-symbols-outlined !text-[16px]">link</span> {{ linkPreview?.title || extractDomain(link) }} </a>
          <p v-if="linkPreview?.description" class="text-gray-600 mt-1 text-xs line-clamp-2">
            {{ linkPreview.description }} </p>
        </div>

        <!-- Link Footer -->
        <div class="mt-3 pt-3 text-xs text-gray-500 flex items-center justify-between border-t border-gray-100">
          <span>{{ extractDomain(link) }}</span> <a :href="link" target="_blank" class="text-primary flex items-center gap-1" @click.prevent="$emit('visit-link', link)">
          <span>{{ t('socialMedia.components.postInspector.visitLink') }}</span> <span class="material-symbols-outlined !text-[14px]">open_in_new</span> </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { urlUtils } from '../../../../../utils/url/url-utils'
import SuggestionButton from '@/components/suggestions/components/SuggestionButton.vue'
import { responseHandlerService } from '@/plugins/responseHandlerService'

const { t } = useI18n()

defineProps({
  message: {
    type: String,
    default: '',
  },
  hashtags: {
    type: Array,
    default: () => [],
  },
  link: {
    type: String,
    default: null,
  },
  linkPreview: {
    type: Object,
    default: () => ({
      title: '',
      description: '',
      image: '',
    }),
  },
  isImageLink: {
    type: Boolean,
    default: false,
  },
  contentId: {
    type: [String, Number],
    default: null,
  },
})

const emit = defineEmits(['visit-link', 'suggestion-created'])

// Using the urlUtils service instead of inline function
function extractDomain(url) {
  return urlUtils.extractDomain(url)
}

// Öneri oluşturulduğunda bildirim gösterme ve olaya ileri aktarma
function handleSuggestionCreated(suggestion) {
  responseHandlerService.handleSuccess('Öneri başarıyla oluşturuldu')
  emit('suggestion-created', suggestion)
}
</script>